var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.usuarioLogado &&
    _vm.cadastroFormulario &&
    _vm.cadastroFormulario.cadastrante
    ? _c(
        "div",
        [
          _vm.tipoCadastro === "NAO_ONEROSO"
            ? _c(
                "el-row",
                { staticClass: "radio-buttons", attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: true },
                          on: { change: _vm.changeTipoCadastrante },
                          model: {
                            value: _vm.radio,
                            callback: function($$v) {
                              _vm.radio = $$v
                            },
                            expression: "radio"
                          }
                        },
                        [_vm._v("Pessoa Física")]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: false },
                          on: { change: _vm.changeTipoCadastrante },
                          model: {
                            value: _vm.radio,
                            callback: function($$v) {
                              _vm.radio = $$v
                            },
                            expression: "radio"
                          }
                        },
                        [_vm._v("Pessoa Jurídica")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.radio
            ? _c(
                "div",
                [
                  _c(
                    "el-row",
                    { staticClass: "labelDiv", attrs: { gutter: 30 } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "inputDiv", attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required|cpf",
                              name: _vm.nomeAba + "/Cpf"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: { label: "CPF:", required: true }
                                      }),
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "mask",
                                            rawName: "v-mask",
                                            value: [
                                              "###.###.###-##",
                                              "##.###.###/####-##"
                                            ],
                                            expression:
                                              "['###.###.###-##', '##.###.###/####-##']"
                                          }
                                        ],
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        attrs: { name: "cadastroChange" },
                                        model: {
                                          value:
                                            _vm.cadastroFormulario.cadastrante
                                              .pessoa.pessoaFisica.cpf,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.cadastroFormulario.cadastrante
                                                .pessoa.pessoaFisica,
                                              "cpf",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "cadastroFormulario.cadastrante.pessoa.pessoaFisica.cpf"
                                        }
                                      }),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3530398028
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "inputDiv", attrs: { span: 16 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: _vm.nomeAba + "/Nome/Razão social"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Nome:",
                                          required: true
                                        }
                                      }),
                                      _c("el-input", {
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        attrs: { maxlength: "300" },
                                        model: {
                                          value:
                                            _vm.cadastroFormulario.cadastrante
                                              .pessoa.pessoaFisica.nome,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.cadastroFormulario.cadastrante
                                                .pessoa.pessoaFisica,
                                              "nome",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "cadastroFormulario.cadastrante.pessoa.pessoaFisica.nome"
                                        }
                                      }),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2045313778
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.tipoCadastro === "ONEROSO"
                    ? _c(
                        "el-row",
                        {
                          staticClass: "labelDiv",
                          staticStyle: { padding: "20px 0" },
                          attrs: { gutter: 30 }
                        },
                        [
                          _c(
                            "el-col",
                            { staticClass: "inputDiv", attrs: { span: 8 } },
                            [
                              _c("app-input-telefone", {
                                attrs: {
                                  telefones: _vm.telefones,
                                  nomeAba: _vm.nomeAba,
                                  requiredTelefones: true,
                                  observer: _vm.observer
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { staticClass: "inputDiv", attrs: { span: 16 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name: _vm.nomeAba + "/E-mail do cadastrante"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "E-mail:",
                                              required: true
                                            }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              name: "E-mail",
                                              maxlength: "100",
                                              label: "email"
                                            },
                                            model: {
                                              value:
                                                _vm.cadastroFormulario
                                                  .cadastrante.pessoa.email,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.cadastroFormulario
                                                    .cadastrante.pessoa,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "cadastroFormulario.cadastrante.pessoa.email"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  847006995
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "el-row",
                    { staticClass: "labelDiv", attrs: { gutter: 30 } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "inputDiv", attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required|cnpj",
                              name: _vm.nomeAba + "/Cnpj"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "CNPJ:",
                                          required: true
                                        }
                                      }),
                                      _c("el-input", {
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        model: {
                                          value:
                                            _vm.cadastroFormulario.cadastrante
                                              .pessoa.pessoaJuridica.cnpj,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.cadastroFormulario.cadastrante
                                                .pessoa.pessoaJuridica,
                                              "cnpj",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "cadastroFormulario.cadastrante.pessoa.pessoaJuridica.cnpj"
                                        }
                                      }),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1764321279
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "inputDiv", attrs: { span: 16 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: _vm.nomeAba + "/Nome/Razão social"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Razão Social:",
                                          required: true
                                        }
                                      }),
                                      _c("el-input", {
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        attrs: { maxlength: "300" },
                                        model: {
                                          value:
                                            _vm.cadastroFormulario.cadastrante
                                              .pessoa.pessoaJuridica
                                              .razaoSocial,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.cadastroFormulario.cadastrante
                                                .pessoa.pessoaJuridica,
                                              "razaoSocial",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "cadastroFormulario.cadastrante.pessoa.pessoaJuridica.razaoSocial"
                                        }
                                      }),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3260601100
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
          _c(
            "el-row",
            { staticClass: "labelDiv", attrs: { gutter: 30 } },
            [
              _c("app-endereco", {
                attrs: {
                  endereco: _vm.cadastroFormulario.cadastrante.pessoa.endereco,
                  estadoCadastrante: _vm.estado,
                  nomeAba: "Cadastrante"
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df1964b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df1964b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/cadastro/CadastranteSicarfRetificacao.vue
// module id = null
// module chunks = 